import script from "./PreciosCompetenciaComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PreciosCompetenciaComponent.vue?vue&type=script&setup=true&lang=js"

import "./PreciosCompetenciaComponent.vue?vue&type=style&index=0&id=1d6a0932&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d6a0932"]])

export default __exports__